import { WAIT_FOR_ACTION, ERROR_ACTION } from "redux-wait-for-action";

export const SEND_AECB_FTS_AUTHORIZATION = "SEND_AECB_FTS_AUTHORIZATION";
export const SEND_AECB_FTS_AUTHORIZATION_SUCCESS = "SEND_AECB_FTS_AUTHORIZATION_SUCCESS";
export const SEND_AECB_FTS_AUTHORIZATION_FAIL = "SEND_AECB_FTS_AUTHORIZATION_FAIL";

export const sendAuthorizationSuccess = () => ({
  type: SEND_AECB_FTS_AUTHORIZATION_SUCCESS
});

export const sendAuthorizationFail = () => ({
  type: SEND_AECB_FTS_AUTHORIZATION_FAIL
});

export const sendAuthorizationPromisify = data => ({
  type: SEND_AECB_FTS_AUTHORIZATION,
  [WAIT_FOR_ACTION]: SEND_AECB_FTS_AUTHORIZATION_SUCCESS,
  [ERROR_ACTION]: SEND_AECB_FTS_AUTHORIZATION_FAIL,
  payload: data
});
